import { createContext } from 'react'
import type { Palette } from './palettes'

export interface ThemeContextValue {
  palette: Palette
  setPalette: (id: string) => void
  highContrast: boolean
  toggleHighContrast: () => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
